// modules
import React from 'react';
import PlatformService from 'modules/Platform';
// ui library
import { CloseIcon, Text, View } from '@upstox/upstox-ui';
// typings
import { Props } from './typings';
// css
import * as css from './styles';

const NotificationBar: React.FC<Props> = props => {
  const { action, boldText, dismissAction, icon, normalText } = props;

  return (
    <View alignItems="center" css={css.notificationContainer}>
      {icon && <View>{icon}</View>}
      <View
        alignItems="center"
        css={css.notificationTextContainer}
        cssProps={{ mobileScreen: PlatformService.isMobile }}
      >
        <View css={css.notificationText}>
          {boldText && <Text css={css.boldText}>{boldText} </Text>}
          <Text css={css.normalText}>{normalText} </Text>
        </View>
        {action && (
          <Text css={css.actionButton} onClick={action.onClick} role="button">
            {action.buttonText}
          </Text>
        )}
      </View>
      {dismissAction && (
        <CloseIcon
          cursor="pointer"
          onClick={dismissAction.onClose}
          size="small"
        />
      )}
    </View>
  );
};

export default NotificationBar;
